export function scheduledClosingId(item) {
  return item?.id ?? item?._id;
}

export function scheduledClosingDescription(item) {
  if (!item || typeof item !== 'object') return '';
  const t = item.description ?? item.content ?? item.message ?? item.body ?? item.notes ?? '';
  return typeof t === 'string' ? t : '';
}

/** API often returns closing_date as ISO datetime (e.g. 2026-05-08T00:00:00.000Z); yields calendar YYYY-MM-DD. */
export function extractScheduledClosingDateOnly(raw) {
  if (raw == null || raw === '') return '';
  if (typeof raw === 'string') {
    const m = raw.match(/^(\d{4}-\d{2}-\d{2})/);
    if (m) return m[1];
    return '';
  }
  try {
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return '';
    return d.toISOString().slice(0, 10);
  } catch {
    return '';
  }
}

export function scheduledClosingDateInputValue(item) {
  return extractScheduledClosingDateOnly(
    item?.closing_date ??
      item?.scheduled_date ??
      item?.scheduled_closing_date ??
      item?.date ??
      item?.closingDate
  );
}

export function formatScheduledClosingDateShort(isoDate) {
  const v = extractScheduledClosingDateOnly(isoDate);
  if (!v) return '—';
  const [y, m, d] = v.split('-').map((n) => parseInt(n, 10));
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/** Month abbreviation and day for calendar-style cards (local calendar date). */
export function formatScheduledClosingCardMonthDay(item) {
  const ymd = scheduledClosingDateInputValue(item);
  if (!ymd) return { month: '—', day: '—' };
  const [y, m, d] = ymd.split('-').map((n) => parseInt(n, 10));
  const date = new Date(y, m - 1, d);
  if (Number.isNaN(date.getTime())) return { month: '—', day: '—' };
  return {
    month: date.toLocaleDateString('en-US', { month: 'short' }),
    day: String(d),
  };
}

export function publicScheduledClosingPath(id) {
  if (id == null || id === '') return '/news-calendar';
  return `/scheduled-closings/${encodeURIComponent(String(id))}`;
}

export function todayLocalISODate() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
